export default "__VITE_ASSET__D9vFQA9C__"